/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class RevenucatEntitlement {
    'entitlement': string;
    'purchaseDate': Date;
    'expiresDate': Date;
    'productIdentifier': string;
    'gracePeriodExpiresDate': Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "entitlement",
            "baseName": "entitlement",
            "type": "string",
            "format": ""
        },
        {
            "name": "purchaseDate",
            "baseName": "purchaseDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "expiresDate",
            "baseName": "expiresDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "productIdentifier",
            "baseName": "productIdentifier",
            "type": "string",
            "format": ""
        },
        {
            "name": "gracePeriodExpiresDate",
            "baseName": "gracePeriodExpiresDate",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return RevenucatEntitlement.attributeTypeMap;
    }

    public constructor() {
    }
}

